import {
  Font,
  Text,
  View,
  Image,
  Svg,
  Path,
  StyleSheet,
} from "@react-pdf/renderer";
import headingImage from "./images/heading-image.png";
import reelLogo from "./images/reel-logo.png";

Font.register({
  family: "Inter",
  fonts: [
    {
      src: "https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyeMZhrib2Bg-4.ttf",
      fontWeight: 100,
    },
    {
      src: "https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuDyfMZhrib2Bg-4.ttf",
      fontWeight: 200,
    },
    {
      src: "https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuOKfMZhrib2Bg-4.ttf",
      fontWeight: 300,
    },
    {
      src: "https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyfMZhrib2Bg-4.ttf",
      fontWeight: 400,
    },
    {
      src: "https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuI6fMZhrib2Bg-4.ttf",
      fontWeight: 500,
    },
    {
      src: "https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuGKYMZhrib2Bg-4.ttf",
      fontWeight: 600,
    },
    {
      src: "https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuFuYMZhrib2Bg-4.ttf",
      fontWeight: 700,
    },
    {
      src: "https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuDyYMZhrib2Bg-4.ttf",
      fontWeight: 800,
    },
    {
      src: "https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuBWYMZhrib2Bg-4.ttf",
      fontWeight: 900,
    },
  ],
});

const styles = StyleSheet.create({
  title: {
    fontFamily: "Inter",
    color: "#424242",
  },
  titleFilled: {
    backgroundColor: "#F0F9FF",
  },
  body: {
    fontFamily: "Inter",
    color: "#424242",
    fontSize: 11,
    fontWeight: 400,
    whiteSpace: "nowrap",
  },
});

export const H1 = ({ children, filled = false }) => (
  <Text
    style={[
      styles.title,
      {
        fontWeight: 700,
        fontSize: 24,
      },
      filled ? styles.titleFilled : {},
    ]}
  >
    {children}
  </Text>
);

export const H2 = ({ children, filled = false }) => (
  <Text
    style={[
      styles.title,
      {
        fontWeight: 700,
        fontSize: 16,
      },
      filled ? styles.titleFilled : {},
    ]}
  >
    {children}
  </Text>
);

export const H3 = ({ children, filled = false }) => (
  <Text
    style={[
      styles.title,
      {
        fontWeight: 600,
        fontSize: 14,
      },
      filled ? styles.titleFilled : {},
    ]}
  >
    {children}
  </Text>
);

export const H4 = ({ children, filled = false }) => (
  <Text
    style={[
      styles.title,
      {
        fontWeight: 600,
        fontSize: 11,
      },
      filled ? styles.titleFilled : {},
    ]}
  >
    {children}
  </Text>
);

export const P = ({ children, style }) => (
  <Text style={{ ...styles.body, ...style }}>{children}</Text>
);

export const FormHeading = ({ title, pharmacyName }) => (
  <View style={{ position: "relative" }}>
    <Image
      src={headingImage}
      style={{
        position: "absolute",
        height: "100%",
        width: "100%",
        objectFit: "cover",
        objectPosition: "bottom",
      }}
    />
    <View
      style={{
        paddingHorizontal: 70,
        paddingTop: 54,
        paddingBottom: 24,
      }}
    >
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginBottom: 16,
          paddingVertical: 2,
        }}
      >
        <Image
          src={reelLogo}
          style={{
            height: 22,
          }}
        />
        <Text
          style={{
            fontFamily: "Inter",
            fontSize: 8,
            fontWeight: 700,
            color: "#000",
            backgroundColor: "#fff",
            paddingHorizontal: 12,
            paddingVertical: 6,
            border: 1,
            borderColor: "#000",
          }}
        >
          {pharmacyName}
        </Text>
      </View>
      <H1>{title}</H1>
    </View>
  </View>
);

export const PageHeading = ({ pharmacyName }) => (
  <View
    style={{
      paddingTop: 36,
      paddingHorizontal: 36,
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    }}
  >
    <View
      style={{
        display: "flex",
        flexDirection: "row",
        gap: 16,
      }}
    >
      <Image
        src={reelLogo}
        style={{
          height: 18,
        }}
      />
      <Text
        style={{
          fontFamily: "Inter",
          fontSize: 6,
          fontWeight: 700,
          color: "#000",
          backgroundColor: "#fff",
          paddingHorizontal: 8.5,
          paddingTop: 4.5,
          paddingBottom: 4,
          border: 1,
          borderColor: "#000",
          opacity: 0.5,
        }}
      >
        {pharmacyName}
      </Text>
    </View>
    <Text
      style={{
        fontFamily: "Inter",
        fontSize: 8,
        fontWeight: 400,
        color: "#424242",
      }}
      render={({ pageNumber, totalPages }) => `${pageNumber} of ${totalPages}`}
    ></Text>
  </View>
);

export const PageContent = ({ children }) => (
  <View
    style={{
      width: "100%",
      paddingHorizontal: 36,
      display: "flex",
      flexDirection: "column",
      gap: 30,
    }}
  >
    {children}
  </View>
);

export const Flex = ({ children, gap = 0, style = {} }) => (
  <View
    style={{
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap,
      ...style,
    }}
  >
    {children}
  </View>
);

export const FlexRow = ({ children, gap = 0, style = {} }) => (
  <View
    style={{
      width: "100%",
      display: "flex",
      flexDirection: "row",
      gap,
      ...style,
    }}
  >
    {children}
  </View>
);

export const TextInput = ({ label = "", value = "", required = false }) => (
  <Flex gap={4}>
    {label ? <P>{(required ? "*" : "") + label}</P> : null}
    <View
      style={{
        display: "flex",
        justifyContent: "center",
        height: 24,
        width: "100%",
        paddingHorizontal: 8,
        backgroundColor: "#FAFAFA",
        border: 1,
        borderColor: "#D0D0D0",
        borderRadius: 4,
      }}
    >
      <P>{value || ""}</P>
    </View>
  </Flex>
);

export const TextAreaInput = ({
  label = "",
  value = "",
  lines = 1,
  required = false,
}) => (
  <Flex gap={4}>
    {label ? <P>{(required ? "*" : "") + label}</P> : null}
    <View
      style={{
        display: "flex",
        justifyContent: "center",
        height: 24 * lines,
        width: "100%",
        paddingHorizontal: 8,
        backgroundColor: "#FAFAFA",
        border: 1,
        borderColor: "#D0D0D0",
        borderRadius: 4,
      }}
    >
      <P>{value || ""}</P>
    </View>
  </Flex>
);

export const CheckInput = ({ checked = false, label = "", minWidth }) => (
  <View
    style={{
      display: "flex",
      flexDirection: "row",
      gap: 8,
      minWidth,
    }}
  >
    <View
      style={{
        width: 14,
        height: 14,
        border: 1,
        borderColor: checked ? "#017E9D" : "#D0D0D0",
        borderRadius: 4,
        backgroundColor: checked ? "#CAD8DE" : "#fff",
      }}
    >
      {!!checked && (
        <Svg
          width={12}
          height={10}
          viewBox="0 0 12 10"
          style={{ marginVertical: "auto" }}
        >
          <Path
            d="M1.5 5.25087L4.41892 8L10.5 1"
            stroke="#017E9D"
            strokeWidth={2}
          />
        </Svg>
      )}
    </View>
    <P>{label}</P>
  </View>
);

export const ListItem = ({ children }) => (
  <FlexRow gap={0}>
    <View style={{ marginHorizontal: 6 }}>
      <P>•</P>
    </View>
    <P>{children}</P>
  </FlexRow>
);
